import React from "react";
import { AppstoreAddOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { PageHeaderLayout } from "../../../shared/layout";
import DownloadAdUnitButton from "../components/DownloadAdUnitButton";
import { fontSize, fontWeight, fontFamily, space, icon as iconSize, text } from "../../Tasks/configs/designTokens";
import { useCreativeNavigation } from "../hooks/useCreativeNavigation";

const PageHeaderLayoutComponent = ({ adgroupinfo, mediaType = "DISPLAY" }) => {
  const { navigateBack } = useCreativeNavigation();
  const creativeKeys =
    adgroupinfo &&
    adgroupinfo.adGroupCreatives &&
    adgroupinfo.adGroupCreatives.medias
      ? adgroupinfo.adGroupCreatives.medias.map(media => media.key)
      : [];
  return (
    <PageHeaderLayout
      title={
        <div style={{
          display: 'flex', alignItems: 'center', gap: space[2], minHeight: space[16],
          fontFamily: fontFamily.base, fontSize: fontSize.title, fontWeight: fontWeight.semibold,
          color: text.heading, letterSpacing: '-0.01em', lineHeight: 1.2, margin: 0,
        }}>
          <AppstoreAddOutlined style={{ fontSize: iconSize.lg }} />
          {adgroupinfo && adgroupinfo.adGroupCreatives
            ? adgroupinfo.adGroupCreatives.name
            : ""}
        </div>
      }
      centerContent={
        <div style={{ display: 'flex', alignItems: 'center', minHeight: space[16], gap: space[2] }}>
          <DownloadAdUnitButton
            creativeKeys={creativeKeys}
            label="Download Ad Group"
          />
          <Button
            type="default"
            size="large"
            onClick={() => navigateBack({
              mediaType: mediaType,
              isAdGroup: true
            })}
          >
            Back
          </Button>
        </div>
      }
    />
  );
};

export default PageHeaderLayoutComponent;
